<template lang="pug">
SingaButton.is-small.is-transparent-dark.spinner( @click="toggleFavorite" :class="{'hide-bg': loadingFavorite}" :disabled="loadingFavorite")
	SingaIcon.favorite-button(v-if="!loadingFavorite" size="small" :icon="favorited ? 'heart' : 'heart-outline'")
	CommonLoadingAnimation(v-else :timeOut="0" :size="24")
</template>

<script setup lang="ts">
const props = defineProps({
	id: {
		type: Number,
		required: true
	},
	resourceId: {
		type: String,
		required: true
	},
	title: {
		type: String,
		required: true
	},
	link: {
		type: String,
		required: true
	},
	accessPoint: {
		type: String,
		required: true
	},
	isFavoriteArtists: {
		type: Boolean,
		default: false
	}
})

const { getFavoriteStatus, loadingFavorite, favorited, toggleFavoriteStatus } = useFavorites()

// Update favorited status when artist's songs are loaded to make sure my the My library buttons stay in sync
useEventOn('artist:getFavoriteStatus', () => {
	favorited.value = getFavoriteStatus('artists', props.id) || null
})

const toggleFavorite = async () => {
	const segmentData = {
		access_point: props.accessPoint,
		artist_id: props.resourceId,
		artist_name: props.title
	}
	if (loadingFavorite.value) {
		return
	}
	await toggleFavoriteStatus('artists', props.id, props.title, props.link, false, segmentData)
	if (!favorited.value) {
		useEventEmit('artist:removeFavorite', props.id)
	}
}

onMounted(() => {
	if (props.isFavoriteArtists) {
		favorited.value = true
	} else {
		favorited.value = getFavoriteStatus('artists', props.id)
	}
})

onUnmounted(() => {
	useEventOff('artist:getFavoriteStatus')
})
</script>

<style lang="sass" scoped>
.button.is-small span
	font-size: 14px !important

.favorite-button
	display: flex
	justify-content: center

.spinner
	max-width: 61px

.button-wrapper
	border: none

.button:disabled
	opacity: 1

.is-transparent-dark
	&.hide-bg
		background: none
</style>
